<template>
  <div id="header" class="page-header-1">
    <!-- 头部 -->
    <div
      class="menuWrapperContainer flex-row"
      :class="{ 'head-skin': isShowLogo }"
    >
      <div class="flex-1 flex-basis-0" v-if="isShowLogo" style="height: 70px">
        <div class="head-left-div">
          <svg-icon icon="deepcat-logo-head" class="head-logo"> </svg-icon>
          <p class="logo-title" v-if="isShowLogo">
            <slot name="title-append"></slot>
          </p>
        </div>
      </div>

      <div class="flex-1 top-menu-area" v-if="!isShowLogo">
        <svg-icon
          icon="cat-unfold"
          class="login-top-menu"
          v-if="!isCollapse"
          @click="changeIsCollapse(true)"
        >
        </svg-icon>
        <svg-icon
          icon="cat-unfold"
          class="login-top-menu flipped"
          v-if="isCollapse"
          @click="changeIsCollapse(false)"
        >
        </svg-icon>
      </div>
      <div
        class="menuWrapper flex-row flex-basis-auto__imp"
        style="z-index: 99"
        v-if="portraitVisible"
      >
        <div class="slot-container">
          <slot name="menu-prefix"></slot>
        </div>
        <el-menu
          v-if="isShowMenu"
          router
          class="flex__no-shrink"
          mode="horizontal"
          :default-active="currentMenu"
          :style="{ 'margin-left': '20px', top: '1px' }"
          text-color="#ffffff"
          active-text-color="#409eff"
          background-color="#39393b"
        >
          <template v-for="item in menus">
            <el-menu-item
              v-if="!item.children || item.children.length <= 0"
              :key="item.id"
              :index="item.url"
              >{{ item.title }}</el-menu-item
            >
            <el-submenu :index="item.url" v-else :key="item.url">
              <template slot="title">{{ item.title }}</template>
              <el-menu-item
                v-for="subItem in item.children"
                :key="subItem.path"
                :index="subItem.url"
                >{{ subItem.title }}</el-menu-item
              >
            </el-submenu>
          </template>
        </el-menu>
        <div class="message-bell flex-center ml-12 mr-6">
          <el-badge
            :hidden="!hasNewNotice"
            is-dot
            class="clickable use-opacity"
          >
            <i
              ref="bellIcon"
              class="el-icon-bell"
              @click="showNoticeDialog"
            ></i>
          </el-badge>
        </div>
        <div
          class="container__tenant clickable use-opacity"
          @click="switchTenant"
        >
          <span class="tenant-name" :title="currentTenant.name || '-'">{{
            currentTenant.name || "-"
          }}</span>
          <i class="el-icon-caret-bottom ml-10"></i>
        </div>
        <div :class="['common-topbar-user-info']">
          <div
            :class="['common-topbar-user-image-wrapper', 'clickable', size]"
            @click.stop="handleUserImageClick"
          >
            <img :src="avaterUrl" />
          </div>
        </div>

        <div class="slot-container">
          <slot name="menu-append"></slot>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="common-topbar-user-info-dropdown" v-show="isUserMenuShown">
      <div class="top">
        <div>
          <img class="rounded-circle" :src="avaterUrl" />
        </div>
        <p class="user-uid" style="cursor: default" :title="userName">
          {{ userName }}
        </p>
        <!-- <a class="user-grade" style="cursor: default">L0</a> -->
      </div>
      <div class="middle" v-if="exitable">
        <a class="middle-line" v-on:click="goUserInfo()">
          <font-awesome-icon
            icon="user"
            class="info-prefix-icon"
          ></font-awesome-icon>
          <span class="left-text">基本资料</span>
        </a>
        <a class="middle-line" v-on:click="goSecuity()">
          <font-awesome-icon
            icon="cog"
            class="info-prefix-icon"
          ></font-awesome-icon>
          <span class="left-text">安全设置</span>
        </a>
        <a class="middle-line" v-on:click="logout()" v-if="exitable">
          <font-awesome-icon
            icon="sign-in-alt"
            class="info-prefix-icon"
          ></font-awesome-icon>
          <span class="left-text">退出</span>
        </a>
      </div>
    </div>
    <NoticePanel :visible.sync="isNoticeDialogShowing"></NoticePanel>
    <el-alert
      title="公告"
      type="warning"
      v-if="hasAffiche"
      style="width: auto; top: 20px; z-index: 8883"
      @close="addAfficheUser"
      class="el-message"
      show-icon
    >
      {{ afficheInfo.afficheText }}
    </el-alert>

    <SelectTenant
      ref="tenantSelector"
      @selected="handleTenantSelected"
    ></SelectTenant>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import configs from "@/configs/pathConfigures";
import String from "@/utils/String";
import NoticePanel from "../../notice/noticePanel.vue";
import { systemMessageConnector } from "../../common/data";
import { getNotReadInfo } from "../../../api/notice";
import afficheAPI from "@/api/stickyAffiche";
import { userType } from "@/views/common/enums";
import SelectTenant from "@/components/selectTenant.vue";
import { genarateAvatarUrl } from "../../../api/user";

export default {
  props: {
    isShowMenu: {
      type: Boolean,
      default: false,
    },
    portraitVisible: {
      type: Boolean,
      default: true,
    },
    exitable: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "large",
    },
    isShowLogo: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NoticePanel,
    SelectTenant,
  },
  data() {
    return {
      userName: this.$store.getters.getUserInfo
        ? this.$store.getters.getUserInfo.username
        : "",
      currentMenu: "",
      titleSwitch: true,

      isNoticeDialogShowing: false,
      hasNewNotice: false,
      hasAffiche: false,
      afficheInfo: null,

      isUserMenuShown: false,
      editAffiching: false,
    };
  },
  watch: {
    $route(newValue) {
      const matched = this.$route.matched[this.$route.matched.length - 1];
      this.currentMenu = matched.redirect || matched.path;
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getTopMenu", "getTenantId", "getTenants"]),
    isCollapse() {
      return this.$store.getters.getIsCollapse;
    },
    menus() {
      var menus = this.getTopMenu || [];
      return menus;
    },
    currentTenant() {
      const tenantId = this.$store.getters.getTenantId;
      const tenants = this.$store.getters.getTenants;
      if (!tenantId || !tenants || tenants.length === 0) return {};
      return tenants.find((tenant) => tenant.id === tenantId);
    },
    avaterUrl() {
      return !!this.getUserInfo && !!this.getUserInfo.avatar
        ? genarateAvatarUrl(this.getUserInfo.avatar)
        : "";
    },
  },
  methods: {
    changeIsCollapse(newValue) {
      this.$store.dispatch("setIsCollapse", newValue);
    },
    logout() {
      this.$store.dispatch("logout", { goLogin: true });
    },
    goSecuity() {
      this.isUserMenuShown = false;
      var path = configs.prefixUrl + "/home/userSetting/security";
      this.$router.push({ path: path, query: { type: "security" } });
    },
    goUserInfo() {
      this.isUserMenuShown = false;
      var path = configs.prefixUrl + "/home/userSetting/userInfo";
      this.$router.push({ path: path, query: { type: "other" } });
    },
    goResource() {
      this.isUserMenuShown = false;
      var path = configs.prefixUrl + "/home/userSetting/resource";
      this.$router.push({ path: path, query: { type: "resource" } });
    },

    showNoticeDialog() {
      this.isNoticeDialogShowing = true;
    },
    _shakeNoticeBell() {
      this.$nextTick(() => {
        const bell = (this.$refs || {}).bellIcon;
        if (!bell) return;

        bell.classList.remove("shake");
        bell.classList.add("shake");
        setTimeout(() => {
          bell.classList.remove("shake");
        }, 2000);
      });
    },
    handleNewNoticeReached() {
      this.hasNewNotice = true;
      this._shakeNoticeBell();
    },
    handleNoticeReaded() {
      this.checkHasNewNotice();
    },
    async handleMessageConnectorReady() {
      const notReadonlyInfo = await getNotReadInfo();
      const hasNewNotice =
        notReadonlyInfo.system.count || notReadonlyInfo.self.count;
      if (hasNewNotice != this.hasNewNotice) {
        this.hasNewNotice = hasNewNotice;
        if (this.hasNewNotice) this._shakeNoticeBell();
      }
    },
    async checkHasNewNotice() {
      console.log("#-# checkHasNewNotice");
      const notReadonlyInfo = await getNotReadInfo();
      console.log("#-# checkHasNewNotice", notReadonlyInfo);
      this.hasNewNotice =
        (notReadonlyInfo.self || {}).count ||
        (notReadonlyInfo.system || {}).count;
    },
    async getAffiche() {
      if (!this.getUserInfo.userId) {
        return;
      }
      if (this.getUserInfo.userType === userType.SchoolAdmin) {
        return;
      }
      try {
        if (!this.hasAffiche && !this.editAffiching) {
          let response = await afficheAPI.getOpenAffiche(this.getUserInfo.id);
          if (!response.data.success) throw response.data.error;
          const afficheInfo = response.data.data;
          if (afficheInfo != null) {
            this.hasAffiche = true;
            this.afficheInfo = afficheInfo;
          } else {
            this.hasAffiche = false;
          }
        }
      } catch (error) {
        this.$$error(error);
      } finally {
        if (!this.editAffiching) {
          this.timeoutID = setTimeout(() => this.getAffiche(), 2000);
        }
      }
    },
    async addAfficheUser() {
      this.editAffiching = true;
      let afficheUserInfo = {
        userId: this.getUserInfo.id,
        afficheId: this.afficheInfo.id,
      };
      await afficheAPI.addStickyAfficheUser(afficheUserInfo);
      this.editAffiching = false;
      this.hasAffiche = false;
    },
    handleUserImageClick() {
      this.isUserMenuShown = !this.isUserMenuShown;
    },

    switchTenant() {
      this.$refs.tenantSelector.showDialog(
        this.getTenants || [],
        this.getTenantId
      );
    },
    async handleTenantSelected(tenant) {
      console.log("switch tenant to ", tenant);
      if (!!tenant && tenant.id != this.getTenantId) {
        await this.$store.dispatch("switchTenantAction", tenant.id);
        const path = this.$router.resolve({ name: "home" });
        window.location.href = path.href;
      }
    },
  },
  mounted() {
    const matched = this.$route.matched[this.$route.matched.length - 1];
    this.currentMenu = matched.redirect || matched.path;
    if (this.portraitVisible) this.checkHasNewNotice();
    //this.getAffiche();
    systemMessageConnector.addEventListener(
      "ready",
      this.handleMessageConnectorReady
    );
    systemMessageConnector.addEventListener(
      "noticeReached",
      this.handleNewNoticeReached
    );
    systemMessageConnector.addEventListener(
      "noticeRead",
      this.handleNoticeReaded
    );

    this._windowClick = (ev) => {
      if (this.isUserMenuShown) {
        let curEle = ev.target;
        while (!!curEle) {
          if (
            curEle.classList &&
            curEle.classList.contains("common-topbar-user-info-dropdown")
          ) {
            break;
          }
          curEle = curEle.parentElement;
        }

        !curEle && (this.isUserMenuShown = false);
      }
    };
    window.addEventListener("click", this._windowClick);
  },
  beforeDestroy() {
    !!this._windowClick &&
      window.removeEventListener("click", this._windowClick);
  },
};
</script>

<style lang="scss">
.page-header-1 {
  .head-skin {
    background: linear-gradient(to right, rgb(89, 101, 249) 0%, #764ba2 100%);
    color: white;
    .login-top-menu {
      color: white;
    }
    .el-icon-bell {
      color: white;
    }
  }
  .head-left-div {
    display: flex;
    height: 70px;
    flex-direction: initial;
  }
  .head-logo {
    font-size: 200px;
    vertical-align: text-bottom;
    margin-top: -65px;
  }
  .flipped {
    transform: rotateY(180deg);
  }
}
.menuWrapperContainer {
  height: 4.375rem;
  background: white;
  color: #606266;
  display: flex;
  align-items: center;
  box-shadow: 5px 7px 26px -5px #bebdcc;

  .top-menu-area {
    padding: 20px 0;
    .login-top-menu {
      font-size: 23px;
      color: #606266;
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .el-icon-bell {
    color: #606266;
  }
}

.menuWrapperContainer > p {
  margin: 0px;
  margin-left: 38px;
  padding: 0px;
  font-weight: bold;
  color: white;
  padding-left: 50px;
  line-height: 61px;
  .main-title-text {
    font-size: 25px;
    font-family: Montserrat, sans-serif;
  }
}

.common-topbar-user-info {
  display: block;
}

.common-topbar-user-info-dropdown {
  top: 90px;
  img {
    width: 4.5rem;
    height: 4.5rem;
  }
  .rounded-circle {
    border-radius: 50% !important;
  }
}

.logo-title {
  position: relative;
  opacity: 0.9;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 8px;
}

.slot-container {
  line-height: 60px;
}

.message-bell {
  font-size: 20px;
  color: white;

  @keyframes bell-shake-animation {
    from {
      transform: rotate(-20deg);
    }

    100% {
      transform: rotate(20deg);
    }
  }

  .el-icon-bell.shake {
    transform-origin: top center;
    animation: bell-shake-animation 0.3s ease-in-out 0s infinite alternate none;
  }
}

.container__tenant {
  font-size: 16px;
  margin: 0 6px 0 10px;

  * {
    line-height: 60px;
  }

  .tenant-name {
    display: inline-block;
    vertical-align: middle;
    max-width: 150px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
